import { combineReducers } from '@reduxjs/toolkit';
import { monitorReducer } from './monitor.slice';
import { issuesReducer } from './issues.slice';
import { dialogReducer } from './dialog.slice';
import { siteReducer } from './site.slice';
import { schedulerReducer } from './scheduler.slice';
import { providerStatusReducer } from './providerStatus.slice';
import { activeScheduleReducer } from './activeSchedule.slice';

export const rootReducer = combineReducers({
  monitor: monitorReducer,
  issues: issuesReducer,
  dialog: dialogReducer,
  siteReducer,
  scheduler: schedulerReducer,
  providerStatus: providerStatusReducer,
  activeSchedule: activeScheduleReducer,
});

export type IRootState = ReturnType<typeof rootReducer>;
